module.exports = __webpack_public_path__ + "df4df29ca50a6d140f3b594f6951c99e.png";